<mat-spinner diameter="50" color="primary" />
